import actions from '@/store/actions';
import mutationGenerators from '@/store/mutations';
import getters from '@/store/getters';
import {merge} from 'lodash';

const state = {
    currentUser: null
};

let mutations = {
    ['STORE_CURRENT_USER'] (state, user) {
        state.currentUser = user;
    }
};

mutationGenerators.forEach(generator => {
    merge(state, generator.generateState());
    merge(mutations, generator.generateMutations());
});

export default {
    strict: process.env.NODE_ENV !== 'production' &&  process.env.NODE_ENV !== 'test',
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
};